import React from "react";
import { Mail, Lock, FileText } from "lucide-react";
import logo from './asset/logo.png'

export default function LoginPage({ loginForm, onFormChange, onLogin, onPageChange }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-emerald-900 flex items-center justify-center px-4">
      <div className="relative bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 w-full max-w-md shadow-2xl animate-fadeIn">
        <div className="text-center mb-8">
         <img
                       src={logo} // replace with your image path
                       alt="Description"
                       
                       className="w-40 h-40 text-white mx-auto mb-4"
                     />
          <h2 className="text-4xl font-bold text-white mb-2">Welcome Back</h2>
          <p className="text-white/70">Sign in to continue</p>
        </div>

        <form onSubmit={onLogin} className="space-y-6">
          <div>
            <label htmlFor="login-email" className="block text-white text-sm font-medium mb-2">
              Email
            </label>
            <div className="relative group">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/50" />
              <input
                id="login-email"
                name="email"
                type="email"
                value={loginForm.email}
                onChange={(e) => onFormChange("email", e.target.value)}
                className="w-full pl-12 pr-4 py-4 bg-white/10 border border-white/20 rounded-xl text-white"
                placeholder="your@email.com"
                required
              />
            </div>
          </div>

          <div>
            <label htmlFor="login-password" className="block text-white text-sm font-medium mb-2">
              Password
            </label>
            <div className="relative group">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/50" />
              <input
                id="login-password"
                name="password"
                type="password"
                value={loginForm.password}
                onChange={(e) => onFormChange("password", e.target.value)}
                className="w-full pl-12 pr-4 py-4 bg-white/10 border border-white/20 rounded-xl text-white"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-emerald-600 text-white py-4 rounded-xl font-bold">
            Sign In
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-white/70 text-sm">
            Don't have an account?{" "}
            <button onClick={() => onPageChange("signup")} className="text-white font-semibold hover:underline">
              Sign up
            </button>
          </p>
          <button onClick={() => onPageChange("landing")} className="mt-4 text-white/70 text-sm hover:text-white">
            ← Back to home
          </button>
        </div>
      </div>
    </div>
  );
}
